import React from 'react'
import PropTypes from 'prop-types'
import Tag from '#components/a/Tag'

function TagList({tags, suffix}) {
  return (
    <div className="tag-list">
      {tags.map(tag => (
        <Tag key={tag.name} {...tag} />
      ))}
      {suffix}
    </div>
  )
}

TagList.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      color: PropTypes.string,
      contrastingTextColor: PropTypes.string,
    }),
  ).isRequired,
  suffix: PropTypes.node,
}

export default TagList
